<template>
  <div class="font-16 px-13 py-9 pb-0">
    <p>
      Articles of personal use normally worn, used or carried by you or your
      family including clothing, baggage, jewellery, watches, spectacles, mobile
      phones, laptops, tablets, media players, electric and pedal bicycles,
      photographic and sports equipment.
    </p>

    <p class="font-weight-bold text-uppercase mt-8">
      Examples of what's covered:
    </p>

    <p>Accidental damage or loss to your personal possessions.</p>
    <p>
      You can claim up to £2,500 per single article item unless they are
      specified on your <i>policy certificate</i>.
    </p>
    <p>
      You can claim up to £1,000 for items left in an unattended motor vehicle.
    </p>

    <p class="font-weight-bold text-uppercase mt-8">
      Examples of what's <u>not</u> covered:
    </p>
    <p>
      Loss or damage occurring outside the United Kingdom if you have spent more
      than 60 days in total away from this country during any consecutive period
      of twelve months.
    </p>
    <p>Loss or damage to musical instruments.</p>
    <p>
      Loss or damage to any property that is not in the care of you or your
      household.
    </p>

    <p>
      Please see the policy terms and conditions for further information on
      Worldwide Belongings Cover. You can find out more information from
      Paymentshield’s website
    </p>
    <div class="d-flex justify-center">
      <BaseButton
        depressed
        text="OK"
        rounded
        width="100%"
        max-width="420"
        height="60"
        dense
        :color="'psorange'"
        class="font-weight-bold font-18 font-lg-20"
        @click="
          $emit('cancelWhatsIncluded', 'showWhatsIncludedPersonalPossessions')
        "
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogContentWhatsIncludedPersonalPossessions",
  components: {
    BaseButton: () => import("@/components/BaseComponents/BaseButton.vue"),
  },
};
</script>

<style lang="scss" scoped></style>
